import Vue from 'vue'
import Router from 'vue-router'
// import iView from 'iview'
import routes from './routers'
import { getToken } from '@/libs/util'
import store from '@/store'
import { masterRoles, ugdRoles } from './constants'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes
})
let noLogin = ['register-em', 'register-smcm', 'login', 'forget', 'modify', '*']
router.beforeEach((to, from, next) => {
  // iView.LoadingBar.start()
  let token = getToken()
  if (!token && !noLogin.includes(to.name)) {
    // 缓存payment页面
    if (to.name === 'personal-payment') {
      localStorage.setItem('paymentRoute', 'personal-payment')
    }
    if (to.name === 'auction') {
      localStorage.setItem('auctionRoute', to.path)
    }
    next({
      name: 'login'
    })
  } else if (token && to.name === 'login') {
    next({
      name: from.name
    })
  } else if (noLogin.includes(to.name)) {
    return next()
  } else {
    // 页面权限
    if (to.meta && to.meta.role && to.meta.role.length) {
      store
        .dispatch('getUserRole')
        .then(res => {
          if (!res.mentorRole) {
            if (
              res.isCM ||
              res.isEM ||
              res.isSM ||
              res.isUGDCM ||
              res.isUGDEM ||
              res.isUGDFAO
            ) {
              next({
                name: 'choose-type'
              })
            } else {
              next({
                name: 'apply-select'
              })
            }
          } else {
            let role = to.meta.role
            if (role.includes(res.mentorRole)) {
              next()
            } else {
              if (ugdRoles.includes(res.mentorRole)) {
                next({
                  name: 'undergraduate-home-index'
                })
              }
              if (masterRoles.includes(res.mentorRole)) {
                next({
                  name: 'home-index'
                })
              }
            }
          }
        })
        .catch(() => {
          next()
        })
    } else {
      next()
    }
    // 之前的路由拦截逻辑
    // if (to.meta && to.meta.role && to.meta.role.length) {
    //   store
    //     .dispatch('getUserRole')
    //     .then(res => {
    //       if (!res.mentorRole) {
    //         if (res.isCM || res.isEM || res.isSM) {
    //           next({
    //             name: 'choose-type'
    //           })
    //         } else {
    //           next({
    //             name: 'apply-select'
    //           })
    //         }
    //       } else {
    //         let role = to.meta.role
    //         let education = to.meta.education
    //         if (role.includes(res.mentorRole)) {
    //           next()
    //         } else {
    //           if (education === 'MASTER') {
    //             next({
    //               name: 'home-index'
    //             })
    //           }
    //           if (education === 'UNDERGRADUATE') {
    //             next({
    //               name: 'undergraduate-home-index'
    //             })
    //           }
    //         }
    //       }
    //     })
    //     .catch(() => {
    //       next()
    //     })
    // } else {
    //   next()
    // }
  }
})
router.afterEach(() => {
  // iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})
export default router
